import React from "react";

// A mini tendencia de um numero principal (spec do redesign, R4.1): a linha do periodo e, a tracejado,
// a do anterior, na mesma escala. Decorativa: o numero e a variacao ja dizem o que importa, e a tabela
// da evolucao tem os valores. Um dia sem valor (uma taxa sem denominador) fica de fora da linha.
const VIEW_HEIGHT = 30;

const Sparkline = ({ current, previous = null, height = 36 }) => {
  const numbers = [...current, ...(previous || [])].filter((value) => value !== null);
  if (numbers.length === 0) return null;
  const min = Math.min(...numbers);
  const span = Math.max(...numbers) - min || 1;
  const points = (list) =>
    list
      .map((value, index) => (value === null ? null : `${list.length === 1 ? 50 : (index / (list.length - 1)) * 100},${28 - ((value - min) / span) * 26}`))
      .filter(Boolean)
      .join(" ");
  return (
    <svg width="100%" height={height} viewBox={`0 0 100 ${VIEW_HEIGHT}`} preserveAspectRatio="none" aria-hidden="true">
      {previous && (
        <polyline points={points(previous)} fill="none" stroke="var(--chart-muted)" strokeWidth="1.5" strokeDasharray="3 3" vectorEffect="non-scaling-stroke" />
      )}
      <polyline points={points(current)} fill="none" stroke="var(--chart-1)" strokeWidth="2" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
    </svg>
  );
};

export default Sparkline;
